export const listingConfigDrawer = {
  close: `Fechar`,
  componentUnavailable: `Componente não disponível.`,
};
